const HomeStrings = {
  title: 'Home',
  screenLabel: 'This is home screen',
  buttonLabelAccountDetails: 'Go to Account Details',
};

export default HomeStrings;
